import { FunctionComponent } from "react"
import { Button, Card } from "react-bootstrap"
import { useNavigate } from "react-router-dom"

interface ISwipeRecordsCard {}
const SwipeRecordsCard: FunctionComponent<ISwipeRecordsCard> = () => {
	const navigate = useNavigate()
	return (
		<Card className="mt-4">
			<Card.Header>Swipe Records</Card.Header>
			<Card.Body>
				<Card.Text>
					<ul>
						<li>View and search keycard swipe records</li>
						<li>Copy a keycard number to assign it to a new resident</li>
					</ul>
					<Button className="mt-4" onClick={() => navigate("/swipe-records")}>
						View Swipe Records
					</Button>
				</Card.Text>
			</Card.Body>
		</Card>
	)
}
export default SwipeRecordsCard
